import urlParse, { qs } from 'url-parse';
const { origin } = urlParse(window.location.href);

export default function(link, queryObject) {
    let href = link;

    if (typeof link === 'function') {
        href = link();
    }

    if (href === null) {
        return null;
    }

    if (!href) href = '';

    if (!href.startsWith('http')) {
        const parsedURL = urlParse(href);
        const { pathname, query } = parsedURL;

        if (queryObject) {
            href = pathname + '?' + qs.stringify(queryObject);
        } else {
            href = `${pathname}${query || ''}`;
        }

        href = origin + '/#' + href;
    }

    return href;
}
